import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const OpportunityCategoryInput = () => {
  const { categoryId = '' } = useParams();
  const decodedId = categoryId ? atob(categoryId) : categoryId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityCategory';

  useEffect(() => {
    if (categoryId) { setIsEditing(true); fetchDetails(); }
  }, [categoryId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['opportunityCategory'] + id + '/', { headers });
      setFormData(response.data?.data ?? response.data);
    } catch (error) { console.error('Error fetching Opportunity Category details:', error); }
  };

  const fields = [{"name":"name","label":"Name","type":"text"},{"name":"description","label":"Description","type":"textarea"}];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Category' : 'Create Opportunity Category'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunityCategoryInput;